import React from 'react'

const Welcome = () => {
  return (
    <section
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        alignItems: 'center',
        gap: '2rem',
        padding: '2rem',
        backgroundColor: '#d7dae0',
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        boxSizing: 'border-box',
      }}
    >
      <div>
        <h2 style={{ marginBottom: '1rem', color: '#1f3d7a', fontSize: '2rem' }}>
          Welcome to ANKURIVF Ferozepur City
        </h2>
        <p style={{ lineHeight: 1.7, color: '#334155', fontSize: '1rem' }}>
          ANKURIVF is Best IVF Center located in Ferozepur. We believe in weaving miracles every day and bestowing the gift of life so that couples can fulfil their journey to complete a family. We have the best IVF specialists in India and offer a wide range of fertility treatments, including IVF and ICSI. We are among India’s Top IVF centres and aim to provide personalized and holistic care to every patient. The advanced IVF clinic has additional facilities like embryo freezing & donor egg IVF. The success rate for IVF in 3 cycle package is Highest Success Rate. The easy EMI option helps in bearing IVF costs & achieve parenthood without any financial burden. ICSI (Intracytoplasmic sperm insemination) is the preferred procedure to achieve high success.
        </p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src="/images/bg.png"
          alt="ANKURIVF clinic"
          style={{ width: '100%', maxWidth: '500px', borderRadius: '12px', objectFit: 'cover' }}
        />
      </div>
    </section>
  )
}

export default Welcome
